import { render, staticRenderFns } from "./checkoutV8.vue?vue&type=template&id=8062e46a&scoped=true"
import script from "./checkoutV8.vue?vue&type=script&lang=js"
export * from "./checkoutV8.vue?vue&type=script&lang=js"
import style0 from "./checkoutV8.vue?vue&type=style&index=0&id=8062e46a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8062e46a",
  null
  
)

export default component.exports